import useTranslate from "hooks/useTranslate";
import { useNavigate } from "react-router-dom";
import "./styles.sass";

type LoyaltyRewardHelp = {
  text: string;
  bntText: string;
  background: string;
  redirectUrl: string;
};

export const LoyaltyRewardHelp = ({
  text,
  bntText,
  background,
  redirectUrl,
}: LoyaltyRewardHelp) => {
  const t = useTranslate();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(redirectUrl);
  };

  return (
    <div className="LoyaltyRewardHelp" style={{ backgroundColor: background }}>
      <span className="LoyaltyRewardHelp__text">{t(text)}</span>
      <button
        type="button"
        className="LoyaltyRewardHelp__btn"
        onClick={handleClick}
      >
        {t(bntText)}
      </button>
    </div>
  );
};
